import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ResourcesStoreEffects } from './effects';
import { ResourcesFacade } from './facade';
import { resourcesFeatureKey, reducers } from './reducers';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(resourcesFeatureKey, reducers),
    EffectsModule.forFeature([ResourcesStoreEffects]),
  ],
  providers: [ResourcesFacade],
})
export class ResourcesStoreModule {}
